import { Field, Float, InputType } from 'type-graphql'
import { InventoryBySerialNumber } from '../../inventorybyserialnumber/InventoryBySerialNumber'

@InputType()
export class UpdateProductInventoryItemArgs {
  @Field(() => String)
  _id: string

  @Field(() => String)
  productId: string

  @Field(() => Float)
  quantity: number

  @Field(() => String)
  remarks?: string

  @Field(() => [InventoryBySerialNumber])
  inventoryBySerialNumbers?: InventoryBySerialNumber[]
}
